import React from 'react';
import { Link } from 'react-router-dom';
import './Mission.css';

function Mission() {
  return (
    <>
      {/* WHAT NN IS */}
      <section className="nn-block">
        <div className="nn-inner">
          <span className="nn-label reveal">The Company</span>
          <h2 className="nn-h2 reveal">What NeXus Neuro is.</h2>
          <p className="nn-p reveal">
            <strong>NeXus Neuroinformatics, Inc.</strong> is a biomedical company that
            specializes in <strong>NeuroChemical AI</strong> powered by <strong>AetherProtocols</strong>.
          </p>
          <p className="nn-p reveal">
            Where generic clinical AI treats each biomarker, physiological signal,
            and patient-reported outcome as an independent input, NN builds AI that
            treats them as coupled observations of one evolving biological system.
            The framework runs on a biology-native compiler with cryptographic
            provenance for every derived measure, engineered from the ground up
            for FDA-regulated drug development and clinical decision-support that
            reviewers can trace to their scientific origin.
          </p>
          <p className="nn-p reveal">
            For healthcare and drug discovery where ISO standards are a necessity:
          </p>
          <p className="nn-p reveal">
            <Link to="/governance" className="nn-btn-gold">See our regulation guide</Link>
          </p>
        </div>
      </section>

      {/* THE FRAMEWORK — AetherProtocols */}
      <section className="nn-block">
        <div className="nn-inner">
          <span className="nn-label reveal">The Framework</span>
          <h2 className="nn-h2 reveal">AetherProtocols</h2>
          <p className="nn-p reveal">
            AetherProtocols is a theoretical framework proposing that clinically
            meaningful digital endpoints should not be constructed from isolated
            biological measurements treated as independent predictors, but from
            computational models of the evolving web of interconnected biological
            pathways from which those observations emerge.
          </p>
          <p className="nn-p reveal">
            Biomarkers, physiology, behavior, language, patient-reported outcomes,
            and clinician-reported outcomes are interpreted as multiple observations
            of the same underlying biological system as it changes over time in
            response to stress, support, and treatment.
          </p>
        </div>
      </section>

      {/* THE MEMORY LAYER — Patent 63/939,190 */}
      <section className="nn-block">
        <div className="nn-inner">
          <span className="nn-label reveal">The Memory Layer</span>
          <h2 className="nn-h2 reveal">Substrate-independent memory weighting.</h2>
          <p className="nn-p reveal">
            <strong>U.S. Provisional Patent 63/939,190</strong> covers the
            memory-weighting mechanism NN's AI infrastructure uses to hold a
            longitudinal state rather than a stack of independent observations.
          </p>
          <p className="nn-p reveal">
            Most clinical AI systems treat memory as a fixed context window that
            is discarded between sessions, or as a retrieval database in which
            every entry is weighted equally at recall time. Both approaches lose
            the temporal dynamics that make longitudinal clinical measurement
            possible. The mechanism covered by this patent weights each stored
            observation by recency, salience, and context, with decay and
            reinforcement dynamics that persist across sessions and across
            compute substrates.
          </p>
          <p className="nn-p reveal">
            Inside NN's infrastructure, this is what turns a continuous stream of
            biomarker, physiological, and clinical observations into a coherent
            state trajectory that can be audited. Every weighted memory carries
            provenance back to the observation that produced it and the decay
            curve that shaped its contribution. The same mechanism is what allows
            AetherProtocols to be traced by reviewers, integrated with regulated
            data systems, and configured across therapeutic areas without
            changing the underlying architecture.
          </p>
        </div>
      </section>

      {/* IP POSITION */}
      <section className="nn-block">
        <div className="nn-inner">
          <span className="nn-label reveal">Intellectual Property</span>
          <h2 className="nn-h2 reveal">Licensed from Nexus Concordat, Inc.</h2>
          <p className="nn-p reveal">
            The underlying computational architecture is owned by Nexus
            Concordat, Inc. and licensed exclusively to NeXus NeuroInformatics,
            Inc. Four U.S. provisional patent applications cover the
            neurochemical language model architecture, substrate-independent
            memory weighting, and two additional filings. Non-provisional
            conversion is scheduled for the December 12, 2026 USPTO deadline.
          </p>
          <div className="nn-patents reveal">
            <span className="nn-patent-tag">U.S. Provisional 63/939,190</span>
            <span className="nn-patent-tag">U.S. Provisional 63/962,385</span>
            <span className="nn-patent-tag">U.S. Provisional 63/988,485</span>
            <span className="nn-patent-tag">U.S. Provisional 64/034,536</span>
          </div>

          <div className="nn-nav-cards reveal">
            <Link to="/qa" className="nn-nav-card">
              <span className="nn-nav-card-label">Reference</span>
              <span className="nn-nav-card-title">Q&amp;A</span>
              <span className="nn-nav-card-arrow">&rarr;</span>
            </Link>
            <Link to="/team" className="nn-nav-card">
              <span className="nn-nav-card-label">People</span>
              <span className="nn-nav-card-title">Meet Our Team</span>
              <span className="nn-nav-card-arrow">&rarr;</span>
            </Link>
            <Link to="/origin" className="nn-nav-card">
              <span className="nn-nav-card-label">Story</span>
              <span className="nn-nav-card-title">Our Origin</span>
              <span className="nn-nav-card-arrow">&rarr;</span>
            </Link>
            <Link to="/contact" className="nn-nav-card">
              <span className="nn-nav-card-label">Reach Us</span>
              <span className="nn-nav-card-title">Contact Us</span>
              <span className="nn-nav-card-arrow">&rarr;</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default Mission;
